








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import DpButton from '@/components/atoms/DpButton/index.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import PerformanceWidget from '@/components/organisms/Performance/PerformanceWidget/index.vue';
import AuthActionTypes from '@/modules/auth/AuthActionTypes';

@Component({
  name: 'MarketRegionOtherMetrics',
  components: {
    PerformanceWidget,
    SvgIcon,
    DpButton,
  },
})
export default class MarketRegionOtherMetrics extends Vue {
  @Action(AuthActionTypes.SHOW_SIMPLE_AUTH_FORM, { namespace: 'auth' })
  protected dispatchShowSimpleAuthForm: any;

  protected onClickUnlock() {
    this.dispatchShowSimpleAuthForm({ isViewAccountPerformance: false });
  }
}
